import { ErrorRenderer } from "@/features/oio/errors"
import { useErrorStore } from "@/features/oio/errors"
import { useRetryStore } from "@/features/oio/errors/retry.store"

/**
 * Renders the global error tier for non-OIO errors (API failures, case operations).
 * Mount this outside OIOWorkspace so errors show even when no draft is open.
 * Fatal errors use the same FatalErrorBanner; warnings auto-dismiss.
 */
export function GlobalErrorRenderer() {
  return (
    <ErrorRenderer
      onRetry={() => {
        const handler = useRetryStore.getState().handler
        useErrorStore.getState().clearAll()
        // If the active workspace registered a retry action (e.g. re-run draft
        // generation), invoke it; otherwise just dismiss the error.
        handler?.()
      }}
    />
  )
}
